import Axios from 'axios';
import _ from 'underscore';
class API {
    constructor() {
        this.endpoint = APP_CONFIG.API_ENDPOINT;
        console.log('Setting default header');
        //Axios.defaults.headers['Content-Type'] = 'application/json';
    }

    setLogOutHandler(callback) {
        Axios.interceptors.response.use(function (response) {
            return response;
        }, function (error) {
            // Do something with response error
            if(_.propertyOf(error)(['response', 'status']) === 401) {
                if(callback) {
                    callback(error.response);
                }
            }
            return Promise.reject(error);
        });
    }

    setUserSID(sid) {
        console.log('USER SID set', sid);
        Axios.defaults.headers.common['X-User-SID'] = sid;
    }

    removeUserSID() {
        console.log('USER Token removed');
        delete Axios.defaults.headers.common['X-User-SID'];
    }

    setToken(token) {
        console.log('Token set', token);
        Axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    }
    
    removeToken() {
        console.log('Token removed...');
        delete Axios.defaults.headers.common['Authorization'];
    }

    getDestinations(destination) {
        return Axios.get(this.endpoint + 'destinations', {
            params: {
                partialDestinationName: destination
            }
        });
    }

    getDestinationById(destinationId, params) {
        params = _.pick(params, ['fromDate', 'toDate']);
        return Axios.get(this.endpoint + 'destinations/' + destinationId, {
            params
        });
    }

    getOffers(params) {
        params = _.pick(params, ['fromDate', 'toDate', 'flexibleStartDays', 'flexibleEndDays', 'departureAirport' , 'destinationId', 'adults', 'children', 'page', 'perPage', 'sortBy', 'sortOrder', 'minPrice', 'maxPrice', 'minHotelCategory', 'roomTypeCode', 'boardTypeCode', 'roomLocatedCode', 'keywords', 'locationId', 'directFlight', 'tourOperator']);
        return Axios.get(this.endpoint + 'offers/package', {
            params
        });
    }

    getFilters(params) {
        params = _.pick(params, ['fromDate', 'toDate' , 'flexibleStartDays', 'flexibleEndDays', 'departureAirport' , 'destinationId', 'adults', 'children']);
        return Axios.get(this.endpoint + 'v2/filters/packageOffers', {params});
    }

    getHotelOffers(hotelId, params) {
        params = _.pick(params, ['fromDate', 'toDate', 'flexibleStartDays', 'flexibleEndDays', 'departureAirport', 'adults', 'children', 'minPrice', 'maxPrice', 'roomTypeCode', 'boardTypeCode', 'roomLocatedCode', 'directFlight', 'tourOperator', 'keywords', 'minHotelCategory', 'sortBy', 'sortDir']);
        return Axios.get(this.endpoint + 'offers/package/' + hotelId, {params});
    }
    
    verifyHotelOffers(offercodes, params) {
        params = _.pick(params, ['adults', 'children', 'directFlight']);
        params.offerCodes = offercodes;
        return Axios.post(this.endpoint + 'offers/verify', params);
    }

    verifyHotelOffer(offercode, params) {
        params = _.pick(params, ['adults', 'children', 'directFlight']);
        return Axios.get(this.endpoint + 'offers/' + offercode, {params});
    }

    getHotel(hotelId, params) {
        params = _.pick(params, ['minHotelCategory']);
        return Axios.get(this.endpoint + 'hotels/' + hotelId, {params});
    }

    getTourOperatorDescription(hotelId, tourOperatorCode, languageCode = 'da') {
        return Axios.get(this.endpoint + 'hotels/' + hotelId + '/tourOperatorDescription', {
            params: {
                tourOperatorCode,
                languageCode
            }
        });
    }

    signupToNewsletter(firstname, lastname, email, interests = 'all') {
        return Axios.post(this.endpoint + 'subscriptions/newsletter', {
            firstName: firstname,
            lastName: lastname,
            email: email,
            interests: interests
        });
    }

    getCountries() {
        return Axios.get(this.endpoint + 'countries');
    }

    getToken(params) {
        params = _.pick(params,['email', 'password', 'passwordResetToken']);
        return Axios.post(this.endpoint + 'tokens', params);
    }

    refreshToken() {
        return Axios.patch(this.endpoint + 'tokens');
    }
    
    passwordReset(email) {
        return Axios.post(this.endpoint + 'tokens/passwordReset', {email});
    }

    validatePasswordResetToken(token) {
        return Axios.get(this.endpoint + 'tokens/passwordReset/' + token);
    }
    
    createUser(params) {
        params = _.pick(params, ['email', 'password', 'firstName', 'lastName', 'address', 'zipCode', 'city', 'countryCode', 'phone', 'subscribeNewsletter']);
        return Axios.post(this.endpoint + 'user', params);
    }

    getUser() {
        return Axios.get(this.endpoint + 'user');
    }

    updateUser(params) {
        params = _.pick(params, ['email', 'password', 'firstName', 'lastName', 'address', 'zipCode', 'city', 'countryCode', 'phone', 'subscribeNewsletter', 'identityChallenge']);
        return Axios.patch(this.endpoint + 'user', params);
    }

    deleteUser() {
        return Axios.delete(this.endpoint + 'user');
    }

    getFavorites() {
        return Axios.get(this.endpoint + 'favorites');
    }

    setFavorite(params) {
        params = _.pick(params, ['search', 'hotel']);
        if(params.search) {
            params.search = _.pick(params.search, ['fromDate', 'toDate', 'flexibleStartDays', 'flexibleEndDays', 'departureAirport', 'destinationId', 'adults', 'children']);
        }

        if(params.hotel) {
            params.hotel = _.pick(params.hotel, ['hotelId', 'fromDate', 'toDate', 'price']);
        }

        return Axios.post(this.endpoint + 'favorites', params);
    }

    deleteFavorite(favoriteId) {
        return Axios.delete(this.endpoint + 'favorites/' + favoriteId);
    }

    makeBooking(bookingDraftId, mock) {
        let options = { };

        if(mock) {
            options = {
                headers: {
                    'X-Mock-Response': mock
                }
            };
        }

        return Axios.post(this.endpoint + 'bookings', {'bookingDraftId': bookingDraftId}, options);
    }

    getBookings() {
        return Axios.get(this.endpoint + 'bookings');
    }

    makeBookingDraft(params) {
        params = _.pick(params, ['offerCode', 'destinationId', 'totalPriceEuro', 'personPriceEuro']);
        return Axios.post(this.endpoint + 'bookings/drafts', params);
    }

    getBookingDraft(draftId, mock) {
        let options = { };

        if(mock) {
            options = {
                headers: {
                    'X-Mock-Response': mock
                }
            };
        }

        return Axios.get(this.endpoint + 'bookings/drafts/' + draftId, options);
    }

    updateBookingDraft(draftId, params) {
        params = _.pick(params, ['travellers', 'customer', 'comment', 'paymentTypeCode', 'paymentTokens', 'totalPriceEuro', 'personPriceEuro', 'subscribeCustomerToNewsletter', 'userConsentedToPriceChange']);
        return Axios.patch(this.endpoint + 'bookings/drafts/' + draftId, params);
    }

    getTownByZip(postal) {
        console.log(postal);
        let axios = Axios.create();
        return axios.get('https://dawa.aws.dk/postnumre/' + postal, {
            transformRequest(data, headers) {
                delete headers.common['Authorization'];
                delete headers.common['X-User-SID'];
                return data;
            }}).then((res) => {
                
            if(res.data.navn) {
                return res.data.navn;
            }

            return false; 
        }).catch((error) => {
            console.error(error);
        });
    }

    submitGroupTravel(params, mock) {
        let url = '/vigtig-information/grupperejsebestilling/submitbooking?ajax=true';
        if(mock) {
            url += '&test=true';
        }

        return Axios.post(url, params, {
            transformRequest(data, headers) {
                delete headers.common['Authorization'];
                delete headers.common['X-User-SID'];
                return data;
            }
        });
    }
}

export default new API();
